'use client';

import { useEffect } from 'react';

/**
 * Registers the PWA service worker in production when explicitly enabled via
 * NEXT_PUBLIC_PWA_ENABLED=true. Dev mode and opt-out builds are a no-op.
 */
export function PwaRegistrar() {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_PWA_ENABLED !== 'true') return;
    if (process.env.NODE_ENV !== 'production') return;
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // silent — SW registration failure must not crash the app
    });
  }, []);
  return null;
}
